let Style = {
  supportedClassProperties: ['base', 'complete', 'error', 'empty', 'focus'],
  supportedStyleProperties: ['base', 'complete', 'error', 'empty'],
  supportedCSSProperties: ['color', 'fontFamily', 'fontSize', 'fontStyle', 
    'textDecoration', 'fontWeight', 'paddingLeft', 'paddingTop', 'paddingRight',
    'paddingBottom', 'padding', 'background'],
  supportedPseudoClasses: [':hover', ':focus'],

  getDefaultCustomClasses: function() {
    return {
      base: 'bambora-checkoutfield',
      complete: 'bambora-checkoutfield-complete',
      empty: 'bambora-checkoutfield-empty',
      focus: 'bambora-checkoutfield-focus',
      error: 'bambora-checkoutfield-error',
    };
  },

  // Parse the argument of style information passed in and return an array of 
  // errors present (if any).
  validateStyleArgument: function(styles) {
    let errors = [];
    for (let group in styles) {
      if (styles.hasOwnProperty(group)) {
        if (this.supportedStyleProperties.indexOf(group) <= -1) {
          errors.push(`'${group}' is not a supported style group`);
        
        } else {
          if (typeof styles[group] !== 'object') {
            errors.push(`style group '${group}' must be an object`);
            continue;
          }

          for (let rule in styles[group]) {
            if (styles[group].hasOwnProperty(rule)) {
              if (this.supportedCSSProperties.indexOf(rule) <= -1 && 
                  this.supportedPseudoClasses.indexOf(rule) <= -1) {
                errors.push(`'${rule}' is not a supported style setting`);
              
              } else if (this.supportedPseudoClasses.indexOf(rule) > -1) {
                if (typeof styles[group][rule] !== 'object') {
                  errors.push(`style property ${rule} must be an object`);
                  continue;
                }

                for (let subRule in styles[group][rule]) {
                  if (styles[group][rule].hasOwnProperty(subRule)) {
                    if (this.supportedCSSProperties.indexOf(subRule) <= -1) {
                      errors.push(`${subRule} is not a supported nested style setting`);

                    } else {
                      if (typeof styles[group][rule][subRule] !== 'string') {
                        errors.push(`style property ${subRule} must be an object`);
                      }
                    }
                  }
                }
              } else {
                if (typeof styles[group][rule] !== 'string') {
                  errors.push(`style property ${rule} must be a string`);
                }
              }
            }
          }
        }
      }
    }
    return errors;
  },

  buildRuleStringFromStyle: function(style) {
    let rules = '';

    if (style.color) {
      rules += `color: ${style.color}; `;
    }

    if (style.fontFamily) {
      rules += `font-family: ${style.fontFamily}; `;
    }

    if (style.fontStyle) {
      rules += `font-style: ${style.fontStyle};`;
    }

    if (style.fontSize) {
      rules += `font-size: ${style.fontSize}; `;
    }

    if (style.textDecoration) {
      rules += `text-decoration: ${style.textDecoration}; `;
    }

    if (style.fontWeight) {
      rules += `font-weight: ${style.fontWeight}; `;
    }

    if (style.paddingLeft) {
      rules += `padding-left: ${style.paddingLeft}; `; 
    }

    if (style.paddingTop) {
      rules += `padding-top: ${style.paddingTop}; `;
    }

    if (style.paddingRight) {
      rules += `padding-right: ${style.paddingRight}; `;
    }

    if (style.paddingBottom) {
      rules += `padding-bottom: ${style.paddingBottom}; `;
    }

    if (style.padding) {
      rules += `padding: ${style.padding}; `;
    }

    if (style.background) {
      rules += `background: ${style.background}; `;
    }
    
    return rules;
  },

};

module.exports = Style;



// WEBPACK FOOTER //
// ./app/style.js